import { createFileRoute } from '@tanstack/react-router'
import { ShippingHistoryPage } from '@/features/dashboard/delivery-request/components/ShippingHistoryPage'

export const Route = createFileRoute('/_dashboard/delivery-requests/$id/shipping-history')({
  component: ShippingHistoryPageRoute,
})

function ShippingHistoryPageRoute() {
  const { id } = Route.useParams()
  return <ShippingHistoryPage deliveryRequestId={Number(id)} />
}